"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useVersion = void 0;
var lodash_isequal_1 = __importDefault(require("lodash.isequal"));
var react_1 = require("react");
var useVersion = function (value) {
    var valueRef = (0, react_1.useRef)(value);
    var _a = (0, react_1.useState)(0), version = _a[0], setVersion = _a[1];
    (0, react_1.useEffect)(function () {
        if (!(0, lodash_isequal_1.default)(valueRef.current, value)) {
            valueRef.current = value;
            setVersion(function (currentVersion) { return currentVersion + 1; });
        }
    }, [value]);
    return version;
};
exports.useVersion = useVersion;
//# sourceMappingURL=useVersion.js.map